import { createCompoundComponent } from '../../utilities'
import { HorizontalGauge as BaseHorizontalGauge } from './HorizontalGauge'
import { HorizontalGaugeBar as Bar } from './HorizontalGaugeBar'

const HorizontalGauge = createCompoundComponent(BaseHorizontalGauge, {
  Bar,
})

export { HorizontalGauge }
